import {Injectable} from '@angular/core';
import {HttpClient} from "@angular/common/http";
import {MvsCrudService} from "../../../../core/shared/service/crud/mvs-crud.service";

@Injectable({
    providedIn: 'root'
})
export class ContractPersonBenefitService extends MvsCrudService {

    constructor(protected http: HttpClient) {
        super(http, MvsCrudService.baseUrl + '/ci/contractPersonBenefits')
    }

    getObjectIcon(): string {
        return 'fa-solid fa-shield-heart';
    }

    getObjectLabels(): string[] {
        return ['benefitType', 'benefitName'];
    }

}
